[
  {
    "id": "first_001",
    "part": "first",
    "name_jp": "あか",
    "name_en": "Aka"
  },
  {
    "id": "first_002",
    "part": "first",
    "name_jp": "いも",
    "name_en": "Imo"
  },
  {
    "id": "first_003",
    "part": "first",
    "name_jp": "うた",
    "name_en": "Uta"
  },
  {
    "id": "first_004",
    "part": "first",
    "name_jp": "えも",
    "name_en": "Emo"
  },
  {
    "id": "first_005",
    "part": "first",
    "name_jp": "おこ",
    "name_en": "Oko"
  },
  {
    "id": "first_006",
    "part": "first",
    "name_jp": "かめ",
    "name_en": "Kame"
  },
  {
    "id": "first_007",
    "part": "first",
    "name_jp": "きら",
    "name_en": "Kira"
  },
  {
    "id": "first_008",
    "part": "first",
    "name_jp": "くる",
    "name_en": "Kuru"
  },
  {
    "id": "first_009",
    "part": "first",
    "name_jp": "けろ",
    "name_en": "Kero"
  },
  {
    "id": "first_010",
    "part": "first",
    "name_jp": "ここ",
    "name_en": "Koko"
  },
  {
    "id": "first_011",
    "part": "first",
    "name_jp": "さき",
    "name_en": "Saki"
  },
  {
    "id": "first_012",
    "part": "first",
    "name_jp": "しお",
    "name_en": "Shio"
  },
  {
    "id": "first_013",
    "part": "first",
    "name_jp": "すも",
    "name_en": "Sumo"
  },
  {
    "id": "first_014",
    "part": "first",
    "name_jp": "せろ",
    "name_en": "Sero"
  },
  {
    "id": "first_015",
    "part": "first",
    "name_jp": "そに",
    "name_en": "Soni"
  },
  {
    "id": "first_016",
    "part": "first",
    "name_jp": "たろ",
    "name_en": "Taro"
  },
  {
    "id": "first_017",
    "part": "first",
    "name_jp": "ちか",
    "name_en": "Chika"
  },
  {
    "id": "first_018",
    "part": "first",
    "name_jp": "つめ",
    "name_en": "Tsume"
  },
  {
    "id": "first_019",
    "part": "first",
    "name_jp": "てと",
    "name_en": "Teto"
  },
  {
    "id": "first_020",
    "part": "first",
    "name_jp": "とこ",
    "name_en": "Toko"
  },
  {
    "id": "first_021",
    "part": "first",
    "name_jp": "なな",
    "name_en": "Nana"
  },
  {
    "id": "first_022",
    "part": "first",
    "name_jp": "にか",
    "name_en": "Nika"
  },
  {
    "id": "first_023",
    "part": "first",
    "name_jp": "ぬん",
    "name_en": "Nun"
  },
  {
    "id": "first_024",
    "part": "first",
    "name_jp": "ねも",
    "name_en": "Nemo"
  },
  {
    "id": "first_025",
    "part": "first",
    "name_jp": "のり",
    "name_en": "Nori"
  },
  {
    "id": "first_026",
    "part": "first",
    "name_jp": "はり",
    "name_en": "Hari"
  },
  {
    "id": "first_027",
    "part": "first",
    "name_jp": "ひき",
    "name_en": "Hiki"
  },
  {
    "id": "first_028",
    "part": "first",
    "name_jp": "ふむ",
    "name_en": "Fumu"
  },
  {
    "id": "first_029",
    "part": "first",
    "name_jp": "へも",
    "name_en": "Hemo"
  },
  {
    "id": "first_030",
    "part": "first",
    "name_jp": "ほい",
    "name_en": "Hoi"
  },
  {
    "id": "first_031",
    "part": "first",
    "name_jp": "まみ",
    "name_en": "Mami"
  },
  {
    "id": "first_032",
    "part": "first",
    "name_jp": "みく",
    "name_en": "Miku"
  },
  {
    "id": "first_033",
    "part": "first",
    "name_jp": "むー",
    "name_en": "Mu"
  },
  {
    "id": "first_034",
    "part": "first",
    "name_jp": "めり",
    "name_en": "Meri"
  },
  {
    "id": "first_035",
    "part": "first",
    "name_jp": "もも",
    "name_en": "Momo"
  },
  {
    "id": "first_036",
    "part": "first",
    "name_jp": "やち",
    "name_en": "Yachi"
  },
  {
    "id": "first_037",
    "part": "first",
    "name_jp": "ゆう",
    "name_en": "Yuu"
  },
  {
    "id": "first_038",
    "part": "first",
    "name_jp": "よし",
    "name_en": "Yoshi"
  },
  {
    "id": "first_039",
    "part": "first",
    "name_jp": "らく",
    "name_en": "Raku"
  },
  {
    "id": "first_040",
    "part": "first",
    "name_jp": "りむ",
    "name_en": "Rimu"
  },
  {
    "id": "first_041",
    "part": "first",
    "name_jp": "るい",
    "name_en": "Rui"
  },
  {
    "id": "first_042",
    "part": "first",
    "name_jp": "れじ",
    "name_en": "Reji"
  },
  {
    "id": "first_043",
    "part": "first",
    "name_jp": "ろき",
    "name_en": "Roki"
  },
  {
    "id": "first_044",
    "part": "first",
    "name_jp": "わじ",
    "name_en": "Waji"
  },
  {
    "id": "last_001",
    "part": "last",
    "name_jp": "いろ",
    "name_en": "iro"
  },
  {
    "id": "last_002",
    "part": "last",
    "name_jp": "きる",
    "name_en": "kiru"
  },
  {
    "id": "last_003",
    "part": "last",
    "name_jp": "きあ",
    "name_en": "kia"
  },
  {
    "id": "last_004",
    "part": "last",
    "name_jp": "しゅう",
    "name_en": "shuu"
  },
  {
    "id": "last_005",
    "part": "last",
    "name_jp": "すけ",
    "name_en": "suke"
  },
  {
    "id": "last_006",
    "part": "last",
    "name_jp": "たろ",
    "name_en": "taro"
  },
  {
    "id": "last_007",
    "part": "last",
    "name_jp": "たん",
    "name_en": "tan"
  },
  {
    "id": "last_008",
    "part": "last",
    "name_jp": "ちー",
    "name_en": "chi"
  },
  {
    "id": "last_009",
    "part": "last",
    "name_jp": "ちゃー",
    "name_en": "cha"
  },
  {
    "id": "last_010",
    "part": "last",
    "name_jp": "ちゃこ",
    "name_en": "chako"
  },
  {
    "id": "last_011",
    "part": "last",
    "name_jp": "ちゃり",
    "name_en": "chari"
  },
  {
    "id": "last_012",
    "part": "last",
    "name_jp": "どん",
    "name_en": "don"
  },
  {
    "id": "last_013",
    "part": "last",
    "name_jp": "った",
    "name_en": "tta"
  },
  {
    "id": "last_014",
    "part": "last",
    "name_jp": "っぱ",
    "name_en": "ppa"
  },
  {
    "id": "last_015",
    "part": "last",
    "name_jp": "っぺ",
    "name_en": "ppe"
  },
  {
    "id": "last_016",
    "part": "last",
    "name_jp": "ぱり",
    "name_en": "pari"
  },
  {
    "id": "last_017",
    "part": "last",
    "name_jp": "ぱる",
    "name_en": "paru"
  },
  {
    "id": "last_018",
    "part": "last",
    "name_jp": "ぱん",
    "name_en": "pan"
  },
  {
    "id": "last_019",
    "part": "last",
    "name_jp": "ぴー",
    "name_en": "pi"
  },
  {
    "id": "last_020",
    "part": "last",
    "name_jp": "ぴゃー",
    "name_en": "pixya"
  },
  {
    "id": "last_021",
    "part": "last",
    "name_jp": "ぴよ",
    "name_en": "piyo"
  },
  {
    "id": "last_022",
    "part": "last",
    "name_jp": "ぴょん",
    "name_en": "pixyon"
  },
  {
    "id": "last_023",
    "part": "last",
    "name_jp": "ぷー",
    "name_en": "pu"
  },
  {
    "id": "last_024",
    "part": "last",
    "name_jp": "ふく",
    "name_en": "fuku"
  },
  {
    "id": "last_025",
    "part": "last",
    "name_jp": "ぷく",
    "name_en": "puku"
  },
  {
    "id": "last_026",
    "part": "last",
    "name_jp": "ふに",
    "name_en": "funi"
  },
  {
    "id": "last_027",
    "part": "last",
    "name_jp": "ぷに",
    "name_en": "puni"
  },
  {
    "id": "last_028",
    "part": "last",
    "name_jp": "ぺけ",
    "name_en": "peke"
  },
  {
    "id": "last_029",
    "part": "last",
    "name_jp": "ぺこ",
    "name_en": "peko"
  },
  {
    "id": "last_030",
    "part": "last",
    "name_jp": "ぺろ",
    "name_en": "pero"
  },
  {
    "id": "last_031",
    "part": "last",
    "name_jp": "ぽこ",
    "name_en": "poko"
  },
  {
    "id": "last_032",
    "part": "last",
    "name_jp": "ぽん",
    "name_en": "pon"
  },
  {
    "id": "last_033",
    "part": "last",
    "name_jp": "まり",
    "name_en": "mari"
  },
  {
    "id": "last_034",
    "part": "last",
    "name_jp": "まる",
    "name_en": "maru"
  },
  {
    "id": "last_035",
    "part": "last",
    "name_jp": "まろ",
    "name_en": "maro"
  },
  {
    "id": "last_036",
    "part": "last",
    "name_jp": "みお",
    "name_en": "mio"
  },
  {
    "id": "last_037",
    "part": "last",
    "name_jp": "みみ",
    "name_en": "mimi"
  },
  {
    "id": "last_038",
    "part": "last",
    "name_jp": "むー",
    "name_en": "mu"
  },
  {
    "id": "last_039",
    "part": "last",
    "name_jp": "めり",
    "name_en": "meri"
  },
  {
    "id": "last_040",
    "part": "last",
    "name_jp": "もこ",
    "name_en": "moko"
  },
  {
    "id": "last_041",
    "part": "last",
    "name_jp": "りん",
    "name_en": "rin"
  },
  {
    "id": "last_042",
    "part": "last",
    "name_jp": "るる",
    "name_en": "ruru"
  },
  {
    "id": "last_043",
    "part": "last",
    "name_jp": "るーん",
    "name_en": "run"
  },
  {
    "id": "last_044",
    "part": "last",
    "name_jp": "ろん",
    "name_en": "ron"
  }
]
